import React from "react";
import { APP_VERSION } from "@/version";

export default function DijitalRoketFooter({ align = "center", compact = false }) {
  return (
    <div className={`text-xs text-slate-500 ${align === "left" ? "text-left" : "text-center"} ${compact ? "" : "py-4"}`}>
      Bu web sitesi{" "}
      <a
        href="https://www.dijitalroket.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="dijital-roket-link"
        className="font-semibold bg-gradient-to-r from-orange-400 via-red-500 to-purple-500 bg-clip-text text-transparent hover:from-orange-300 hover:to-purple-400 transition-colors"
      >
        Dijital Roket
      </a>
      {" "}tarafından geliştirilmiştir.
      <span className="ml-2 text-slate-600" data-testid="app-version">v{APP_VERSION}</span>
    </div>
  );
}
